import React, { useState, useEffect, useContext } from "react";
import { Container } from "@saif/container";
import { RequiredIndicator } from "@saif/required-indicator";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./RequestAccess.scss";
import { Heading } from "@saif/heading";
import { SaifFetch, API_ACTION } from "../../Utils/SaifFetch";
import useSaifFetch from "../../hooks/useSaifFetch";
import { LoadingSpinner } from "@saif/loading-spinner";
import { ILocalizationContext } from "../../Localization/Models/ILocalizationContext";
import LocalizationContext from "../../Localization/LanguageContext";
import PolicyHolderRFA from "../../Components/Forms/PolicyHolderRFA";

const RequestAccess = () => {
  const { getValue, locale, setLocale } = useContext(
    LocalizationContext
  ) as ILocalizationContext;

  const [dataFail, setDataFail] = useState<boolean>(false);

  const [body, setBody] = useState({});

  const { data, loading, status, error } = useSaifFetch<any>(
    API_ACTION.Request_Access,
    body,
    SaifFetch.post
  );

  let navigator = useNavigate();

  let [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get("Culture") === "es") {
      setLocale("es");
    }
  }, [searchParams, setLocale]);

  useEffect(() => {
    if (status === 200) {
      console.log(data);
      setDataFail(false);
      if (data["response"] === "Blocked") {
        navigator("/Blocked");
      } else if (data["response"] === "Steward") {
        navigator("/forwarded");
      } else if (data["response"] === "Success") {
        navigator("/success", { replace: false });
      } else if (data["response"] === "Invalid") {
        setDataFail(true);
      } else navigator("/error");
    } else if (status === 400) {
      setDataFail(true);
    } else if ((status && status >= 401) || error) {
      navigator("/error");
    }
  }, [status, data, error, navigator]);

  const handleSubmit = (userData: {
    FirstName: string;
    LastName: string;
    EmailAddress: string;
    PolicyNumber: string;
    FEIN: string;
    Language: string;
    permissions: string[];
  }) => {
    try {
      setBody(userData);
    } catch (err) {
      setDataFail(true);
    }
  };

  return (
    <>
      {loading && (
        <LoadingSpinner
          className="loading"
          text={getValue("RequestAccess", "Validating")}
        />
      )}
      <Container
        className="confirmation-content"
        columnCount={1}
        verticalAlign="center"
      >
        <div className="request-wrapper">
          <div className="request-access-title px-0">
            <Heading size="xl" underline="primary" isLoading={loading}>
              {getValue("RequestAccess", "Title")}
            </Heading>
            <p className="request-access-subtitle">
              {getValue("RequestAccess", "TitleSub")}
              &nbsp;
              <RequiredIndicator required={true} />
              &nbsp;
              {getValue("RequestAccess", "TitleSub2")}
            </p>
          </div>
          <PolicyHolderRFA
            getValue={getValue}
            locale={locale}
            dataFail={dataFail}
            onSubmit={handleSubmit}
          />
        </div>
      </Container>
    </>
  );
};

export default RequestAccess;